import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { LIGHT_GREY } from "styles/oneOffColor";

import { FormAnswer } from "features/Influencer/Templates/TemplatesTable/CreateTemplate/schema";

const styles = {
  chipAnnotation: {
    backgroundColor: "#f1f3f3",
    borderRadius: 6,
    color: "green.main",
    width: "max-content",
    px: 2,
    py: 1,
    display: "block",
    margin: "auto",
    mb: 2,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "white",
    },
  },
};

interface Props {
  handleSubmit: () => void;
  handleBack: () => void;
  form: FormAnswer;
  setForm: React.Dispatch<React.SetStateAction<FormAnswer>>;
}

const TemplateAdditionalInfoForm = ({
  handleSubmit,
  handleBack,
  form,
  setForm,
}: Props) => {
  return (
    <Grid>
      <Box sx={styles.chipAnnotation}>💭 Let's answer a few questions</Box>
      <Typography
        textAlign="center"
        variant="h3"
        gutterBottom
        sx={{ textAlign: "center", fontSize: { xs: 20, md: 28 } }}
      >
        Anything you'd like us to know or to incorporate in your pitch?
      </Typography>

      <Grid container justifyContent="center">
        <Grid item xs={12} sx={{ width: { xs: "auto", md: 600 }, mx: "auto" }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="E.g. mention my upcoming collaboration with Nike, keep the tone casual, avoid using buzzwords..."
            value={form.additionalInfo || ""}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, additionalInfo: e.target.value }))
            }
            sx={styles.textField}
          />
        </Grid>
      </Grid>

      <Grid container justifyContent={"center"} gap={1} sx={{ mt: 4 }}>
        <Button
          sx={{ px: 3, py: 1, backgroundColor: LIGHT_GREY }}
          onClick={handleBack}
          disableElevation
        >
          <Box
            component="i"
            className="fa-regular fa-circle-arrow-left"
            sx={{ mr: 1 }}
          />{" "}
          Back
        </Button>

        <Button
          sx={{ minWidth: 200, py: 1 }}
          variant="contained"
          onClick={handleSubmit}
          disableElevation
        >
          Generate Template
        </Button>
      </Grid>
    </Grid>
  );
};

export default TemplateAdditionalInfoForm;
